var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 71,
    height: 71,
    rx: 10,
    fill: "#13A9E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2065 23.7999C34.9402 22.3136 37.0597 22.3136 37.7934 23.7999L40.4276 29.1365C40.7186 29.7262 41.281 30.1351 41.9317 30.2303L47.8257 31.0918C49.4656 31.3314 50.1191 33.3471 48.9319 34.5034L44.6702 38.6544C44.1985 39.1138 43.9831 39.7761 44.0945 40.4252L45.0998 46.2869C45.3801 47.9209 43.665 49.1668 42.1977 48.3952L36.9309 45.6254C36.3481 45.3189 35.6518 45.3189 35.0691 45.6254L29.8022 48.3952C28.335 49.1668 26.6199 47.9209 26.9001 46.2869L27.9055 40.4252C28.0168 39.7761 27.8015 39.1138 27.3297 38.6544L23.068 34.5034C21.8808 33.3471 22.5344 31.3314 24.1742 31.0918L30.0682 30.2303C30.7189 30.1351 31.2813 29.7262 31.5724 29.1365L34.2065 23.7999Z",
    fill: "#13A9E8",
    stroke: "#13A9E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.177823eeef6d7d3730b813901693cda8.svg";
export { ForwardRef as ReactComponent };